import React from "react";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { getHeaderClass } from "../../utils/agGridHelpers";

/**
 * Get column definitions for PayPurpose grid
 */
export const getPaypurposeColumns = (role, handleEditClick, handleDeleteClick) => [
  {
    headerName: "Actions",
    width: 120,
    headerClass: getHeaderClass,
    cellRenderer: (params) => {
      if (!params.data) return null;

      return (
        <div style={{ display: "flex", gap: "10px" }}>
          {(role === "admin1" ||
            role === "admin2" ||
            role === "superadmin" ||
            role === "editor2" ||
            role === "editor1") && (
            <IconButton
              title="Edit"
              style={{ color: "#1976d2" }}
              aria-label="Edit Donor"
              data-log="Edit Icon Button"
              onClick={() => handleEditClick(params)}
            >
              <EditIcon />
            </IconButton>
          )}

          {(role === "superadmin" ||
            role === "admin1" ||
            role === "admin2") && (
            <IconButton
              onClick={() => handleDeleteClick(params)}
              title="Delete donation"
              style={{ color: "#d32f2f" }}
              data-log="Delete Icon Button"
            >
              <DeleteIcon />
            </IconButton>
          )}
        </div>
      );
    },
  },
  {
    headerName: "Donor ID",
    field: "donorId",
    sortable: true,
    filter: "agNumberColumnFilter",
    width: 100,
    headerClass: getHeaderClass,
  },
  {
    headerName: "Transaction ID",
    field: "transactionId",
    sortable: true,
    filter: "agNumberColumnFilter",
    width: 130,
    headerClass: getHeaderClass,
  },
  {
    headerName: "Child Receipt No",
    field: "childReceiptNo",
    headerClass: getHeaderClass,
    sortable: true,
    filter: "agTextColumnFilter",
    valueGetter: (params) => {
      const receiptNo = params.data?.receiptNo || "";
      const childReceiptNo = params.data?.childReceiptNo || "";
      return childReceiptNo ? `${receiptNo}-${childReceiptNo}` : receiptNo;
    },
    comparator: (valueA, valueB) => {
      const parseValue = (val) => {
        if (!val) return [0, 0];
        const parts = val.split("-").map((p) => parseInt(p, 10) || 0);
        return parts.length === 1 ? [parts[0], 0] : parts;
      };

      const [rA, cA] = parseValue(valueA);
      const [rB, cB] = parseValue(valueB);

      if (rA !== rB) return rA - rB;
      return cA - cB;
    },
    sort: "asc",
  },
  {
    headerName: "Amount",
    field: "amount",
    sortable: true,
    filter: "agNumberColumnFilter",
    headerClass: getHeaderClass,
  },
  {
    headerName: "Pay Purpose",
    field: "payPurpose",
    sortable: true,
    filter: "agTextColumnFilter",
    headerClass: getHeaderClass,
  },
  {
  headerName: "sankalpa Name",
  field: "tributeName",
  sortable: true,
  filter: "agTextColumnFilter",
  headerClass: getHeaderClass,
},
  {
    headerName: "Sharma",
    field: "sharma",
    sortable: true,
    filter: "agTextColumnFilter",
    headerClass: getHeaderClass,
  },
  {
    headerName: "Pooja Date",
    field: "poojaDate",
    sortable: true,
    headerClass: getHeaderClass,
    filter: "agTextColumnFilter",
    comparator: (valueA, valueB, nodeA, nodeB) => {
      const dateA = nodeA.data.poojaSortDate || new Date(0);
      const dateB = nodeB.data.poojaSortDate || new Date(0);
      return dateA - dateB;
    },
    valueFormatter: (params) => params.value || "",
  },
  {
    headerName: "Tamil Months",
    field: "tamilMonths",
    sortable: true,
    filter: "agTextColumnFilter",
    headerClass: getHeaderClass,
  },
  // {
  //   headerName: "English Months",
  //   field: "englishMonths",
  //   sortable: true,
  //   filter: "agTextColumnFilter",
  //   headerClass: getHeaderClass,
  // },
  {
    headerName: "Nachathiram",
    field: "nachathiram",
    sortable: true,
    filter: "agTextColumnFilter",
    headerClass: getHeaderClass,
  },
  {
    headerName: "Thithi",
    field: "thithi",
    sortable: true,
    filter: "agTextColumnFilter",
    headerClass: getHeaderClass,
  },
  {
    headerName: "Utsavam",
    field: "utsavam",
    sortable: true,
    filter: "agTextColumnFilter",
    headerClass: getHeaderClass,
  },
  {
    headerName: "Complete",
    field: "complete",
    sortable: true,
    filter: "agTextColumnFilter",
    headerClass: getHeaderClass,
  },
];
